export const loadingParts = 7;
//# sourceMappingURL=index.js.map